export const getUnixTimestamp = () => {
  return Math.floor(Date.now() / 1000);
};

export const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const convertNumber = (string) => {
  const phone = String(string).replace(/(\+38| )/gi, '');
  return phone.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/gi, '$1 $2 $3 $4');
};

export const downloadFileFromBase64 = (name, base64, ext) => {
  const a = document.createElement('a');
  a.href = base64;
  if (ext) {
    a.download = `${name}.${ext}`;
  } else {
    a.download = name;
  }

  a.click();
};

/// Превращает объект элементов в HTTP query
export const httpBuildQuery = (params) => {
  if (Object.keys(params).length === 0) {
    return '';
  }

  return (
    '?' +
    Object.entries(params)
      .filter(([key, value]) => value !== undefined)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
  );
};
